import gsap from "gsap";
import { ANIMATION, parallaxVertical, animateObserver, animateWords } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";
import CLASSES from "./utils/class";

(() => {
  "use strict";

  const BRHCollage = () => {
    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        const collages = document.querySelectorAll(CLASSES.main);
        if (collages.length > 0) {
          collages.forEach((collage) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: collage,
                toggleActions: "none none none none",
                start: `top+=10% center`,
                end: `bottom center`,
                scrub: true,
                markers: false,
              },
            });

            const multimedias = collage.querySelectorAll(ANIMATION.selectors.parallaxVerticalInnerImages);
            multimedias.forEach((multimedia) => {
              multimedia.classList.contains("brh-collage__image--1") && timeline.add(parallaxVertical({ classElement: multimedia, startsY: -10, endsY: 40 }), 0);
              multimedia.classList.contains("brh-collage__image--3") && timeline.add(parallaxVertical({ classElement: multimedia, startsY: -10, endsY: 40 }), 0);
            });

            const appearances = gsap.timeline();
            const titles = collage.querySelectorAll(ANIMATION.selectors.animatedWords);
            titles.length > 0 && appearances.add(animateWords({ classElement: titles }), 0);

            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: collage, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHCollage);
})();
